import { SearchPage } from '../search-page';
import { AutocompletePlugin } from './store/plugins/AutocompletePlugin';
import { DataStorageSyncPlugin } from './store/plugins/DataStorageSyncPlugin';
import { DependencyCheckerPlugin } from './store/plugins/DependencyCheckerPlugin';
import { ListenForPortalTypePlugin } from './store/plugins/ListenForPortalTypePlugin';
import { ModalManager } from '@studyportals/modal';
import { IAppRegistration, IAppState, SearchType } from '@studyportals/search-page-interface';
import store from './store';
import { RoutingRegistration } from './router/RoutingRegistration';
import { App } from 'vue';
import RefreshTextPlugin from './store/plugins/RefreshTextPlugin';
import { PostHogExperimentsPlugin } from './store/plugins/PostHogExperimentsPlugin';

export class StudySearch {
	private readonly searchPage: SearchPage;

	public constructor(searchPage?: SearchPage) {
		this.searchPage = searchPage ?? SearchPage.instance;
	}

	//! Do not remove this parameter, it is used in vue-globals.ts (Magic)
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	public install(_app: App): void {
		const appRegistration = this.createAppRegistration();
		this.searchPage.registerApplication(appRegistration);

		window.ModalManager = new ModalManager();

		new PostHogExperimentsPlugin().initiate();
		void new DependencyCheckerPlugin().initiate();
		void new RefreshTextPlugin().initiate();
		void new DataStorageSyncPlugin().initiate();
		void new AutocompletePlugin().initiate();
		void new ListenForPortalTypePlugin().initiate();
	}

	private isPathForThisApp(path: string): boolean {
		const regex = /^\/(master|bachelor|phd|course|distance-learning)(\/|$)/;
		return regex.test(path);
	}

	private createAppRegistration(): IAppRegistration {
		const routingRegistration = new RoutingRegistration();

		return {
			type: SearchType.STUDY,

			availableFilters: store.getters.getFilters().map((_) => _.key),
			routing: routingRegistration,

			activate: (state: IAppState): void => {
				void store.actions.activate(state);
			},

			sleep: (): IAppState => {
				return store.actions.sleep();
			},

			initializeFrom: (state: IAppState): void => {
				store.actions.initializeFrom(state);
			},

			isPathForThisApp: (path: string): boolean => {
				return this.isPathForThisApp(path);
			}
		};
	}
}
